import { Chip } from "@mui/material";
import type { PartyDto } from "Infrastructure/Api/Api";
import { PAYMENT_STATUS_TO_INFO } from "Utils/SettlementUtils";

type Props = {
  party: PartyDto;
};

export const SettlementPaymentCell = ({
  party: { publicID, settlementStatus },
}: Props) => {
  if (!publicID) {
    return null;
  }

  if (!settlementStatus) {
    return <span>-</span>;
  }

  const { label, backgroundColor } = PAYMENT_STATUS_TO_INFO[settlementStatus];

  return (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor, color: "white", fontWeight: 600 }}
    />
  );
};
